import { jsPDF } from 'jspdf';
import moment from 'moment';
import 'jspdf-autotable';
import { orderBy, toLower, snakeCase } from 'lodash';

export const exportAppointmentsPdf = (
  date,
  clinic,
  appointments,
  siteName,
  customField,
) => {
  const doc = new jsPDF();

  const {
    organization: { name: orgName },
    sublocation: { address, city, state, country, postal_code: postalCode },
  } = clinic;

  const textLeftPosition = 14;

  doc.setFontSize('11');
  doc.text(`Clinic Name: ${siteName}`, textLeftPosition, 10);
  doc.text(`Organization: ${orgName}`, textLeftPosition, 17);
  doc.text(
    `Address: ${address}, ${city}, ${state}, ${postalCode}, ${country}`,
    textLeftPosition,
    24,
  );
  doc.text(
    `Clinic Date: ${moment(date).format('dddd, MMMM D, YYYY')}`,
    textLeftPosition,
    31,
  );
  doc.autoTable({
    startY: 40,
    head: [
      [
        'Time Slot',
        'First Name',
        'Last Name',
        customField || null,
        'Email',
        'Phone Number',
      ],
    ],
    theme: 'striped',
    body: appointments.map((appointment) => Object.values(appointment)),
    showHead: 'everyPage',
    showFoot: 'everyPage',
  });

  doc.save(
    `${snakeCase(toLower(siteName))}--${moment(date).format(
      'MMM_DD_YYYY',
    )}.pdf`,
  );
};
